import {ChangeDetectorRef, Directive, ElementRef, Input, Optional, Self} from '@angular/core';
import {NgControl} from '@angular/forms';
import {NormalizerFactory} from './normalizer.factory';
import {NormalizerI} from './normalizer.i';

/**
 * Directive, which adds normalizers by type attribute
 */
@Directive({
    selector: 'input[type]',
    host: {
        '(keypress)': 'onInputChange()',
        '(blur)': 'onInputBlur()',
        '(keyup)': 'onInputChange()',
    }
})
export class TypeNormalizerDirective {

    @Input('type') normalizerType: string;
    @Input() normalizeOnBlur = true;

    normalizer: NormalizerI;
    currentValue: any;

    constructor(@Optional() @Self() public formControl: NgControl, private cd: ChangeDetectorRef, private element: ElementRef) {
    }

    onInputChange() {
        this.normalizeValue();
    }

    onInputBlur() {
        if (this.normalizeOnBlur) {
            this.onInputChange();
        }
    }

    private normalizeValue() {
        //todo andrey move to constructor and remove listener if not exists
        this.normalizer = NormalizerFactory.getNormalizer(this.normalizerType);
        if (!this.normalizer) {
            return;
        }
        if (this.formControl) {
            this.currentValue = this.formControl.value;
            const normalizeValue = this.normalizer.normalize(this.currentValue);
            this.formControl.control.setValue(normalizeValue);
        } else if (!this.formControl) {
            this.currentValue = this.element.nativeElement.value;
            this.element.nativeElement.value = this.normalizer.normalize(this.currentValue);
        } else {
            return;
        }

        this.cd.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/normalizer.directive.ts